module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-76x76-e68bfe3a4d549a5922e16843b2811510.png";